/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createFileRoute } from '@tanstack/react-router'
import { redirectAccountShortcut } from '@web/src/lib/account/redirect-account-shortcut'

export const Route = createFileRoute('/(public)/account/general')({
  beforeLoad: ({ context }) => redirectAccountShortcut({ context, section: 'general' }),
  component: () => null,
})
